import React from 'react';

interface DisconnectedStateProps {
  onConnect: () => void;
  isLoading?: boolean;
}

export const DisconnectedState: React.FC<DisconnectedStateProps> = ({ onConnect, isLoading = false }) => {
  return (
    <main 
      className="min-h-screen flex items-center justify-center wa-gradient-bg wa-animate-fadeIn" 
      style={{ padding: 'var(--wa-space-4)' }}
      role="main"
      aria-label="Tela de conexão do WhatsApp"
    >
      <section 
        className="wa-card wa-card-body text-center" 
        style={{ maxWidth: '28rem', width: '100%' }}
        aria-labelledby="app-title"
      >
        {/* Icon */}
        <header style={{ marginBottom: 'var(--wa-space-6)' }}>
          <div 
            className="wa-gradient-yellow-primary flex items-center justify-center mx-auto wa-animate-scaleIn wa-hover-scale"
            style={{ 
              width: 'var(--wa-space-20)', 
              height: 'var(--wa-space-20)', 
              borderRadius: 'var(--wa-rounded-full)',
              marginBottom: 'var(--wa-space-4)',
              cursor: 'pointer',
              border: '2px solid var(--wa-yellow-400)',
              boxShadow: '0 6px 20px rgba(255, 193, 7, 0.25)'
            }}
            role="img"
            aria-label="Ícone do WhatsApp"
          >
            <span style={{ fontSize: 'var(--wa-text-3xl)', color: 'var(--wa-yellow-900)' }} aria-hidden="true">📱</span>
          </div>
          <h1 id="app-title" className="wa-heading-2" style={{ marginBottom: 'var(--wa-space-2)' }}>
            Whats Automation
          </h1>
          <p className="wa-body-small" style={{ color: 'var(--wa-gray-500)' }}>
            Automação profissional para WhatsApp
          </p>
        </header>

        {/* Connect Button */}
        <button
          onClick={onConnect}
          disabled={isLoading}
          className="wa-btn wa-btn-lg wa-focus-ring wa-hover-glow"
          style={{
            width: '100%',
            background: isLoading ? 'var(--wa-gray-400)' : 'var(--wa-gradient-yellow-primary)',
            color: isLoading ? 'white' : 'var(--wa-yellow-900)',
            border: isLoading ? 'none' : '2px solid var(--wa-yellow-400)',
            fontWeight: 'var(--wa-font-semibold)',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? '0.7' : '1'
          }}
          aria-label={isLoading ? "Conectando ao WhatsApp" : "Conectar ao WhatsApp"}
          aria-describedby="connect-description"
        >
          {isLoading ? (
            <div className="flex items-center justify-center" style={{ gap: 'var(--wa-space-3)' }}>
              <div 
                className="wa-animate-spin"
                style={{ 
                  width: 'var(--wa-space-5)', 
                  height: 'var(--wa-space-5)', 
                  border: '2px solid white',
                  borderTopColor: 'transparent',
                  borderRadius: 'var(--wa-rounded-full)'
                }}
                role="status"
                aria-label="Carregando"
              ></div>
              <span>Iniciando conexão...</span>
            </div>
          ) : (
            <div className="flex items-center justify-center" style={{ gap: 'var(--wa-space-2)' }}>
              <span aria-hidden="true">🚀</span>
              <span>Conectar ao WhatsApp</span>
            </div>
          )}
        </button>

        <p id="connect-description" className="wa-caption" style={{ color: 'var(--wa-gray-500)', marginTop: 'var(--wa-space-2)', textAlign: 'center' }}>
          Clique para iniciar a conexão com seu WhatsApp
        </p>

        {/* Features */}
        <section 
          style={{ marginTop: 'var(--wa-space-8)', display: 'flex', flexDirection: 'column', gap: 'var(--wa-space-3)' }}
          aria-labelledby="features-title"
        >
          <h2 id="features-title" className="wa-body-small" style={{ fontWeight: 'var(--wa-font-semibold)', marginBottom: 'var(--wa-space-2)' }}>
            Recursos disponíveis:
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 'var(--wa-space-3)' }}>
            <li className="flex items-center wa-body-small wa-interactive" style={{ gap: 'var(--wa-space-3)' }}>
              <span style={{ color: 'var(--wa-success-500)' }} aria-label="Disponível">✅</span>
              <span>Envio em massa para grupos</span>
            </li>
            <li className="flex items-center wa-body-small wa-interactive" style={{ gap: 'var(--wa-space-3)' }}>
              <span style={{ color: 'var(--wa-success-500)' }} aria-label="Disponível">✅</span>
              <span>Interface intuitiva e responsiva</span>
            </li>
            <li className="flex items-center wa-body-small wa-interactive" style={{ gap: 'var(--wa-space-3)' }}>
              <span style={{ color: 'var(--wa-success-500)' }} aria-label="Disponível">✅</span>
              <span>Conexão segura e estável</span>
            </li>
          </ul>
        </section>
      </section>
    </main>
  );
};